import {Injectable} from '@angular/core';
import {ActionSheetController, AlertController, Platform} from 'ionic-angular';
import {AbstractActionSheet} from '../../../../../shared/components/action-sheet/abstract';

/**
 * Class for the ImageShortcodeActionSheet
 * @class
 */
@Injectable()
export class ImageShortcodeActionSheet extends AbstractActionSheet {

  constructor(public actionSheetCtrl: ActionSheetController,
              public platform: Platform,
              public alertCtrl: AlertController) {
    super(actionSheetCtrl, platform, alertCtrl);
  }

  /** @inheritdoc */
  present(opts: object, status: string = null) {
    return super.present(Object.assign({
      buttons: this.getButtons(),
      cssClass: 'image-shortcode-action-sheet',
      enableBackDropDismiss: true,
    }, opts), status);
  }

  /**
   * Get the buttons for this action sheet
   * @protected
   * @returns {any}
   */
  protected getButtons(): any {
    return [
      {
        handler: () => {
          this.actionSheet.dismiss('preview');
          return false;
        },
        icon: 'paper',
        text: 'Preview',
        cssClass: 'preview-button',
      },
      // TODO: PRMOBILE-22 activate this
      // {
      //   handler: () => this.onEdit.emit({}),
      //   icon: 'create',
      //   text: 'Edit',
      //   cssClass: 'edit-button',
      // },
      {
        handler: () => {
          this.actionSheet.dismiss('remove');
          return false;
        },
        icon: 'trash',
        text: 'Remove',
        cssClass: 'remove-button',
      },
      {
        icon: 'close',
        text: 'Cancel',
        cssClass: 'cancel-button',
      },
    ];
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/action-sheet/image-shortcode-action-sheet/image-shortcode-action-sheet.component.ts